import { render } from "./Topos.vue?vue&type=template&id=1877d34c&scoped=true"
import script from "./Topos.vue?vue&type=script&lang=js"
export * from "./Topos.vue?vue&type=script&lang=js"

import "./Topos.vue?vue&type=style&index=0&id=1877d34c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1877d34c"]])

export default __exports__